import React from "react";
import PropTypes from "prop-types";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDModal from "@cloudpremise/portal_core/src/themes/mui/components/MDModal";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";


const ItemModal = (props) => {
    let defaultState = {
        UnitNo: "",
        Shipper: "",
        BeneficialOwner: "",
        LE: "",
        ServiceLevel: "",
        UnitType: "",
        PlannedIG: "",
        ActualIGDateTime: "",
        CustomerRequestDateTime: "",
        GoalDateTime: "",
        Origin: "",
        WaybillDest: "",
        CurrentEvent: "",
        CurrentEventDateTime: "",
        BOLNo: "",
        PickupNo: "",
        LotLocation: "",
        item: null,
    };
    if(props.item !== null){
        defaultState = {
            ...defaultState,
            ...props.item,
            item: props.item
        };
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    return (
        <MDModal
            open={props.open}
            footer={
                (
                    <MDButton key="cancel" variant="gradient" color="light" onClick={() => props.onCancel(state.item)} >
                        Close
                    </MDButton>
                )
            }
            onClose={() => props.onCancel(state.item)}
            title={"Shipment Detail"}
        >
            <div className="slds-p-around_medium">
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Unit #: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.UnitNo}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Shipper: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.Shipper}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Beneficial Owner: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.BeneficialOwner}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        LE: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.LE}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Service Level: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.ServiceLevel}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Unit Type: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.UnitType}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Planned IG: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.PlannedIG}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Actual IG D/T: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.ActualIGDateTime}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Customer Request D/T: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.CustomerRequestDateTime}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Goal D/T: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.GoalDateTime}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Origin: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.Origin}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Waybill Dest: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.WaybillDest}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Current Event: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.CurrentEvent}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Current Event D/T: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.CurrentEventDateTime}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        BOL #: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.BOLNo}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Pickup #: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.PickupNo}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Lot Location: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.LotLocation}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Consignee: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.Consignee}
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" py="5px" pr={2}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Notify Party: &nbsp;
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{state.NotifyParty}
                    </MDTypography>
                </MDBox>
            </div>
        </MDModal>
    )
};

ItemModal.defaultProps = {
    item: null
}
ItemModal.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    onDelete: PropTypes.func,
    open: PropTypes.bool,
    item: PropTypes.object,
    verifiedEntity: PropTypes.object,
    basename: PropTypes.string,
    saving: PropTypes.bool
};

export default ItemModal;